import React from 'react'
import { Button } from 'components/Button/Button'
import styles from './SignupStep2.module.scss'


type Props = {
    onSubmit?: () => void;
}

export function SignupStep2(props: Props) {
    function handleSubmit() {
        props.onSubmit()
    }

    return (
        <div className={styles['wrapper']}>
            <div className={styles['title']}>
                Support or receive?
            </div>
            <div className={styles['description']}>
                Do you want to receive help or support others?
                Later, you can easily switch between the profile of the Patron and the Creator.
            </div>
            <div className={styles['buttons']}>
                <Button
                    size='m'
                    type='dark'
                    iconName='forward'
                    iconRight
                    onClick={handleSubmit}
                >
                    Support
                </Button>
                <Button
                    size='m'
                    type='dark'
                    iconName='forward'
                    iconRight
                    onClick={handleSubmit}
                >
                    Receive
                </Button>
            </div>
        </div >
    );
}

